// extracted by mini-css-extract-plugin
export default {"frame":"PdfPreview_frame__sNEez","pdf_page":"PdfPreview_pdf_page__8zy7I"};